import { createVar, style, styleVariants } from '@vanilla-extract/css';
import {
  borderWidthVars,
  fontWeightVars,
  radiusVars,
  smallTextPreset,
  spacingVars,
} from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import { BadgeColor, BadgeEmphasis } from './Badge.types';

const toneBase = createVar();
const toneSubtle = createVar();
const toneBorder = createVar();

export const toneClasses = styleVariants({
  [BadgeColor.SUCCESS]: {
    vars: {
      [toneBase]: semanticTokenVars.feedback.success.default.base,
      [toneSubtle]: semanticTokenVars.feedback.success.default.subtle,
      [toneBorder]: semanticTokenVars.feedback.success.default.base,
    },
  },
  [BadgeColor.WARNING]: {
    vars: {
      [toneBase]: semanticTokenVars.feedback.warning.default.base,
      [toneSubtle]: semanticTokenVars.feedback.warning.default.subtle,
      [toneBorder]: semanticTokenVars.feedback.warning.default.base,
    },
  },
  [BadgeColor.DANGER]: {
    vars: {
      [toneBase]: semanticTokenVars.feedback.error.default.base,
      [toneSubtle]: semanticTokenVars.feedback.error.default.subtle,
      [toneBorder]: semanticTokenVars.feedback.error.default.base,
    },
  },
  [BadgeColor.INFO]: {
    vars: {
      [toneBase]: semanticTokenVars.feedback.info.default.base,
      [toneSubtle]: semanticTokenVars.feedback.info.default.subtle,
      [toneBorder]: semanticTokenVars.feedback.info.default.base,
    },
  },
  [BadgeColor.NEUTRAL]: {
    vars: {
      [toneBase]: semanticTokenVars.content.subtle.default,
      [toneSubtle]: semanticTokenVars.accent.grey.default.subtle,
      [toneBorder]: semanticTokenVars.border.neutral.default.idle,
    },
  },
});

export const baseClass = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: spacingVars.xs,
  borderRadius: radiusVars['2xl'],
  ...smallTextPreset,
  fontWeight: fontWeightVars.bold,
  whiteSpace: 'nowrap',
  padding: `${spacingVars.xs} ${spacingVars.sm}`,
  color: toneBase,
  width: 'fit-content',
  maxWidth: '100%',
});

export const emphasisClasses = styleVariants({
  [BadgeEmphasis.PRIMARY]: {
    backgroundColor: toneSubtle,
  },
  [BadgeEmphasis.SECONDARY]: {
    backgroundColor: 'transparent',
    border: `${borderWidthVars.xs} solid ${toneBorder}`,
  },
});

export const dotClass = style({
  width: 6,
  height: 6,
  borderRadius: radiusVars['2xl'],
  backgroundColor: toneBase,
  flexShrink: 0,
});

export const textClass = style({
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const iconClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});

/** Square layout for `BadgeVariant.ICON_ONLY`: sized by the glyph plus its padding. */
export const iconOnlyBaseClass = style({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: radiusVars['2xl'],
  padding: spacingVars.md,
  width: 'fit-content',
  flexShrink: 0,
  backgroundColor: toneSubtle,
  color: toneBase,
});
